export class Score {
    label: String;
    valor: String;
}
